import { Component, Inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IuiModalWindowModule, IuiModalWindowRef, IUI_MODAL_WINDOW_DATA } from '@itero/ui-components-angular/modal-window';
import { StatusInfoModalDialogData } from '@shared/iosim-plus/models/status-info-modal-dialog.model';

@Component({
	selector: 'eup-status-info-modal-dialog',
	standalone: true,
	imports: [TranslateModule, NgIf, IuiModalWindowModule],
	templateUrl: './status-info-modal-dialog.component.html',
	styleUrls: ['./status-info-modal-dialog.component.scss'],
})
export class StatusInfoModalDialogComponent {
	constructor(
		private readonly modalRef: IuiModalWindowRef,
		@Inject(IUI_MODAL_WINDOW_DATA) public readonly data: StatusInfoModalDialogData,
	) {}

	close(): void {
		this.modalRef.close();
	}

	retry(): void {
		this.modalRef.close('retry');
	}
}
